import React from 'react'
import { useLazyList } from './useLazyList'
import AccountLazySentinel from './AccountLazySentinel'

const AccountLazyItems = ({ items = [], pageSize, children }) => {
  const { visibleItems, sentinelRef, hasMore } = useLazyList(items, pageSize)

  return (
    <>
      {visibleItems.map((item, index) => children(item, index))}
      <AccountLazySentinel sentinelRef={sentinelRef} hasMore={hasMore} />
    </>
  )
}

export default AccountLazyItems
